import { render, staticRenderFns } from "./UpdateServicesDialog.vue?vue&type=template&id=0cffa3b3"
import script from "./UpdateServicesDialog.vue?vue&type=script&lang=js"
export * from "./UpdateServicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports